import { _ as _extends } from '../../extends-30811c5e.js';
import { _ as _defineProperty } from '../../defineProperty-6f298737.js';
import { _ as _objectWithoutProperties } from '../../objectWithoutProperties-dd908bcc.js';
import React__default from 'react';
import classNames from 'classnames';

var _excluded = ["className"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var LogoYoutube = function LogoYoutube(_ref) {
  var _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    newProps = _objectWithoutProperties(_ref, _excluded);
  var props = _objectSpread(_objectSpread({}, newProps), {}, {
    className: classNames('sol-illustration', className)
  });
  return /*#__PURE__*/React__default.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), /*#__PURE__*/React__default.createElement("g", {
    id: "logo.youtube"
  }, /*#__PURE__*/React__default.createElement("g", {
    id: "logo-youtube",
    clipPath: "url(#clip0_4223_6535)"
  }, /*#__PURE__*/React__default.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.5204 5.48272C29.891 5.85186 30.9718 6.93242 31.3407 8.30326C32.0262 10.8072 31.9999 16.0263 31.9999 16.0263C31.9999 16.0263 31.9999 21.2189 31.3409 23.7231C30.9718 25.0937 29.8912 26.1745 28.5204 26.5434C26.0162 27.2025 15.9999 27.2025 15.9999 27.2025C15.9999 27.2025 6.00974 27.2025 3.47948 26.5172C2.10863 26.1481 1.02807 25.0673 0.658933 23.6967C0 21.2189 0 16 0 16C0 16 0 10.8072 0.658933 8.30326C1.02783 6.93266 2.135 5.82549 3.47923 5.4566C5.98337 4.79742 15.9997 4.79742 15.9997 4.79742C15.9997 4.79742 26.0162 4.79742 28.5204 5.48272ZM21.1397 16.0003L12.8104 20.7976V11.2029L21.1397 16.0003Z",
    fill: "#FF0000"
  }))), /*#__PURE__*/React__default.createElement("defs", null, /*#__PURE__*/React__default.createElement("clipPath", {
    id: "clip0_4223_6535"
  }, /*#__PURE__*/React__default.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  }))));
};

export { LogoYoutube };
